<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        class="text-center"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <v-row class="custom-cursor">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              id="textoTotalAberto"
              class="text-left"
            >
              <b>Total Aberto</b>
            </div>
            <v-row id="carteiraPedidosAberto">
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
              >
                <div
                  id="idValorAberto"
                  class="text-right"
                  :style="styleObject"
                >
                  {{ valorAberto }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="1"
                md="1"
                lg="1"
              >
                <v-icon
                  id="idIconSearchAberto"
                  :style="styleObject"
                  @click="detalhePedidos(aberto = true)"
                >
                  mdi-clipboard-text-search-outline
                </v-icon>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              id="textoTotalMes"
              class="text-left"
            >
              <b>Total à Faturar Mês</b>
            </div>
            <v-row id="carteiraPedidosMes">
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
              >
                <div
                  id="idValorMes"
                  class="text-right"
                  :style="styleObject"
                >
                  {{ valorFatMes }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="1"
                md="1"
                lg="1"
              >
                <v-icon
                  id="idIconSearchMes"
                  class="text-right"
                  :style="styleObject"
                  @click="detalhePedidos(mes = true)"
                >
                  mdi-clipboard-text-search-outline
                </v-icon>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              id="textoTotalDia"
              class="text-left"
            >
              <b>Total Emitido Dia</b>
            </div>
            <v-row id="carteiraPedidosDia">
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
              >
                <div
                  id="idValorDia"
                  class="text-right"
                  :style="styleObject"
                >
                  {{ valorPedidoDia }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="1"
                md="1"
                lg="1"
              >
                <v-icon
                  id="idIconSearchDia"
                  class="text-right"
                  :style="styleObject"
                  @click="detalhePedidos(dia = true)"
                >
                  mdi-clipboard-text-search-outline
                </v-icon>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <template>
      <v-dialog
        v-model="dialog.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="1000px"
        content-class="custom-dialog-content"
        @keydown.esc="dialog.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialog.visible = false, excluirPagina = true"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text
            class="text-center"
          >
            <h4>{{ dialog.message }}</h4>
          </v-card-text>
          <v-card-text
            class="pb-3 pt-6 text-center"
            style="white-space: pre-line"
          >
            <div
              id="idTableDetalhe"
              style="overflow-x: auto;"
            >
              <table
                style="width: 100%; color: black; border-collapse: collapse;"
                class="elevation-1"
                mobile-breakpoint="0"
              >
                <thead>
                  <tr>
                    <th
                      v-for="h in headersClients"
                      id="dadoMovimentacaoHeader"
                      :key="h.id"
                      style="text-align: center;"
                      class="black--text title"
                    >
                      {{ h.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in dadosDetalhe"
                    :key="item.id"
                  >
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: right;"
                    >
                      {{ item.pedido }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: left;"
                    >
                      {{ item.status }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: left;"
                    >
                      {{ item.cliente }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: left;"
                    >
                      {{ item.vendedor }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: left;"
                    >
                      {{ item.periodo }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: right;"
                    >
                      {{ item.valor }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
  import Comercial from '../../../../../services/comercial4'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowCarteiraPedidos',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectCarteiraPedidos: {
        color: '#9d9ac5',
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      valorAberto: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFatMes: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPedidoDia: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      pedidoAberto: [],
      pedidoMes: [],
      pedidoDia: [],
      dadosDetalhe: [],
      aberto: false,
      mes: false,
      dia: false,
      headersClients: [
        { text: 'Num. Pedido', value: 'pedido', width: '95px', align: 'left', class: 'black--text title' },
        { text: 'Status', value: 'status', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', class: 'black--text title' },
        { text: 'Data', value: 'periodo', align: 'left', class: 'black--text title' },
        { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
      ],
      dialog: {
        visible: false,
        message: '',
        valor: 0,
      },
    }),

    created () {
      eventEmit.$on('update-datas', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-datas', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita

        this.showDadosPedidos()
      },

      async showDadosPedidos () {
        this.loading = true

        this.valorAberto = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFatMes = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPedidoDia = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.pedidoAberto = []
        this.pedidoMes = []
        this.pedidoDia = []
        this.dadosDetalhe = []

        await Comercial.showDadosPedidos(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorAberto = resposta.data.valorAberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorFatMes = resposta.data.valorFaturadoMes.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorPedidoDia = resposta.data.valorFaturadoDia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.pedidoAberto = this.getDados(resposta.data.detalheAberto)

            this.pedidoMes = this.getDados(resposta.data.detalheMes)

            this.pedidoDia = this.getDados(resposta.data.detalheDia)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      detalhePedidos () {
        if (this.aberto) {
          this.dadosDetalhe = this.pedidoAberto

          this.showDialog('Total Pedidos Aberto', this.aberto)

          this.aberto = false
        } else if (this.mes) {
          this.dadosDetalhe = this.pedidoMes

          this.showDialog('Total Pedidos Faturados no Mês', this.mes)

          this.mes = false
        } else if (this.dia) {
          this.dadosDetalhe = this.pedidoDia

          this.showDialog('Total Pedidos Emitido no Dia', this.dia)

          this.dia = false
        }
      },

      getDados (dados) {
        var dadosDetalhe = []

        dadosDetalhe = dados.map((item) => {
          var listaDados = ({
            pedido: item.pedido,
            status: item.status,
            cliente: item.cliente,
            vendedor: item.vendedor,
            periodo: item.periodo,
            valor: item.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
          })

          return listaDados
        })

        return dadosDetalhe
      },

      showDialog (message, valor) {
        this.dialog.visible = true
        this.dialog.message = message
        this.dialog.valor = valor
      },
    },
  }
</script>

<style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
    and (min-device-width : 320px)
    and (max-device-width : 680px) {
      #textoTotalAberto {
        margin: 2rem 0 0 5rem;
      }

      #carteiraPedidosAberto {
        margin: auto;
        font-size: 14px;
      }

      #idValorAberto.text-right {
        text-align: left !important;
        margin: 0 0 0 4.3rem;
      }

      #idIconSearchAberto {
        margin: -6.5rem 0 0 13rem
      }

      #textoTotalMes {
        margin: -2rem 0 0 5rem;
      }

      #carteiraPedidosMes {
        margin: auto;
        font-size: 14px;
      }

      #idValorMes.text-right {
        text-align: left !important;
        margin: 0 0 0 4.3rem;
      }

      #idIconSearchMes {
        margin: -6.5rem 0 0 13rem
      }

      #textoTotalDia {
       margin: -3rem 0 0 5rem;
      }

      #carteiraPedidosDia {
        margin: auto;
        font-size: 14px;
      }

      #idIconSearchDia {
        margin: -6.5rem 0 0 13rem
      }

      #idValorDia.text-right {
        text-align: left !important;
        margin: 0 0 0 4.3rem;
      }

      #dadoMovimentacaoDetalhe {
        font-size: 9px;
      }

      th, td {
        padding: 8px;
      }
    }

  @media screen
    and (min-width : 681px)
    and (max-width : 1000px)
    and (-webkit-min-device-pixel-ratio: 1) {
      /* #textoTotalAberto {
      margin: 1rem 0 0 -4rem
    }

    #carteiraPedidosAberto {
      margin: 0 0 0 12.5rem;
    }

    #idIconSearchAberto {
      margin: 0rem 0 0 -33rem
    }

    #textoTotalMes {
      margin: 0 0 0 -2rem;
    }

    #carteiraPedidosMes {
      margin: 0 0 0 9rem;
    }

    #idIconSearchMes {
      margin: 0rem 0 0 -37rem;
    }

    #textoTotalDia {
      margin: 0 0 0 -2.5rem;
    }

    #carteiraPedidosDia {
      margin: 0 0 0 6rem;
    }

    #idIconSearchDia {
      margin: 0rem 0 0 -36rem;
    } */
  }

  @media screen
    and (min-width : 1380px)
    and (max-width : 1600px)
    and (-webkit-min-device-pixel-ratio: 1) {
    /* #textoTotalAberto {
      margin: 1rem 0 0 -4rem
    }

    #carteiraPedidosAberto {
      margin: 0 0 0 9.5rem;
    }

    #idIconSearchAberto {
      margin: 0rem 0 0 -13rem
    }

    #textoTotalMes {
      margin: 0 0 0 -2rem;
    }

    #carteiraPedidosMes {
      margin: 0 0 0 6rem;
    }

    #idIconSearchMes {
      margin: 0rem 0 0 -17rem;
    }

    #textoTotalDia {
      margin: 0 0 0 -2.5rem;
    }

    #carteiraPedidosDia {
      margin: 0 0 0 4rem;
    }

    #idIconSearchDia {
      margin: 0rem 0 0 -16rem;
    } */
  }

  @media screen
    and (min-width : 1601px)
    and (-webkit-min-device-pixel-ratio: 1) {
    /* #textoTotalAberto {
      margin: 1rem 0 0 -4rem
    }

    #carteiraPedidosAberto {
      margin: 0 0 0 9.5rem;
    }

    #idIconSearchAberto {
      margin: 0rem 0 0 -15rem
    }

    #textoTotalMes {
      margin: 0 0 0 -2rem;
    }

    #carteiraPedidosMes {
      margin: 0 0 0 6rem;
    }

    #idIconSearchMes {
      margin: 0rem 0 0 -19rem;
    }

    #textoTotalDia {
      margin: 0 0 0 -2.5rem;
    }

    #carteiraPedidosDia {
      margin: 0 0 0 4rem;
    }

    #idIconSearchDia {
      margin: 0rem 0 0 -18rem;
    } */

    #textoTotalAberto {
       margin: 3rem 0 0 15.2rem
    }

    #textoTotalDia {
      margin: -1rem 0 0 15.2rem
    }

    #textoTotalMes {
      margin: -1rem 0 0 15.2rem
    }
  }
</style>

<style lang="sass">
  #textoTotalAberto
    margin: 1rem 0 0 5rem

  #carteiraPedidosAberto
    font-size: 16px
    font-weight: bold
    margin: 0rem 0 0 -64rem

  // #idIconSearchAberto
    // margin: 0 0 0 -10rem

  #textoTotalMes
    margin: 1rem 0 0 5rem

  #carteiraPedidosMes
    font-size: 16px
    font-weight: bold
    margin: 0rem 0 0 -63.7rem

  // #idIconSearchMes
    // margin: 0 0 0 -13.5rem

  #textoTotalDia
    margin: 1rem 0 0 5rem

  #carteiraPedidosDia
    font-size: 16px
    font-weight: bold
    margin: 0rem 0 0 -63.6rem

  #idIconSearchDia
    // margin: 0rem 0 0 -12rem

  .custom-cursor
    cursor: default

</style>
